import { trpc } from '@/lib/trpc';

const useGetPublicList = (public_uid: string) => {
	const { data, error, isLoading } = trpc.list.getPublic.useQuery(
		{
			public_uid,
		},
		{ enabled: !!public_uid }
	);

	return { list: data?.list, listError: error, listLoading: isLoading };
};

export default useGetPublicList;
